  document.addEventListener("DOMContentLoaded", function () {
    const openButton = document.querySelector('.compare-wrapper sc-compare-dialog-open-button');

    if (!openButton) return;

    function showButtonIfDialogExists() {
      const dialog = document.querySelector('sc-compare-dialog');
      if (dialog) {
        openButton.style.display = 'block';
        return true;
      } else {
        openButton.style.display = 'none';
        return false;
      }
    }

    // Step 1: Immediate check
    const found = showButtonIfDialogExists();

    // Step 2: If not found, observe DOM for future injection
    if (!found) {
      const observer = new MutationObserver((mutationsList, observerInstance) => {
        for (const mutation of mutationsList) {
          for (const node of mutation.addedNodes) {
            if (node.tagName === 'SC-COMPARE-DIALOG') {
              openButton.style.display = '';
              observerInstance.disconnect(); // Stop observing after it's found
              return;
            }
          }
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  });